
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Weil sie im Magen und Darm oft nicht mehr gut aufgenommen werden, wenn der Anfall voll ausgeprägt ist.Voraussetzung für die Medikamenteneinnahme ist:`}</p>
    <ul> <li> dass es sicher eine Migräne ist.</li> <li> Wer ein Triptan einnimmt, sollte dies erst tun, wenn die Aura vorüber ist. </li> <li> dass es weniger als 10 Tage mit Schmerzmittel pro Monat sind.</li></ul><Link href='https://schmerzklinik.de/wp-content/uploads/2009/02/die_triptanschwelle.pdf' mdxType="Link">
Diese kleine Checkliste</Link> hilft dabei, die «Triptanschwelle», also den besten Einnahmezeitpunkt für ein Triptan, zu ermitteln.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;